import axios from 'axios';

class MitAnalyticsTracker {
    constructor() {
        this.sessionId = this._getOrSetSessionId();
        this.isInitialized = false; // Add a state flag
    }

    _getOrSetSessionId() {
        let sid = localStorage.getItem('mit_analytics_sid');
        if (!sid) {
            sid = crypto.randomUUID();
            localStorage.setItem('mit_analytics_sid', sid);
        }
        return sid;
    }

    async initSession() {
        // Only fire the POST request if it hasn't been done yet
        if (this.isInitialized) return; 

        try {
            await axios.post('/api/v2/analytics/session', { sessionId: this.sessionId });
            this.isInitialized = true; // Mark as successfully initialized
        } catch (e) {
            console.warn("Analytics blocked or failed");
        }
    }

    async track(category, metricName, metricData = {}) {
        // Optionally, ensure the session exists before tracking
        await this.initSession(); 

        try {
            await axios.post('/api/v2/analytics/event', {
                sessionId: this.sessionId,
                category: category,
                metricName: metricName,
                metricData: metricData
            });
        } catch (e) {
            console.warn("Analytics event failed to log");
        }
    }
}

export default new MitAnalyticsTracker();